module.exports = __webpack_public_path__ + "static/img/newanli-05.13d508bb.jpg";